import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function usePageTitle(titleKey: string, descriptionKey?: string) {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    const apply = () => {
      const title = t(titleKey)
      if (title && title !== titleKey) {
        document.title = title
      }
      if (descriptionKey) {
        const description = t(descriptionKey)
        const meta = document.querySelector('meta[name="description"]')
        if (meta && description && description !== descriptionKey) {
          meta.setAttribute('content', description)
        }
      }
    }

    apply()
    i18n.on('languageChanged', apply)
    return () => {
      i18n.off('languageChanged', apply)
    }
  }, [t, i18n, titleKey, descriptionKey])
}
